import { useMemo } from 'react';

import { FilterOption } from '@common/models';
import {
    filterAllEntries,
    getSelectedFiltersMap,
    initializeFiltersOptions,
} from '@core/components/filters/filterUtils';
import { useAppSelector } from '@redux/hooks';
import { RefrigeratorFilters, selectRefrigeratorFilters } from '@redux/slices/refrigeratorSlice';

import useRefrigerator from './useRefrigerator';

const useRefrigeratorFilters = () => {
    const { browsedRefrigerators } = useRefrigerator();
    const _refrigeratorFilters = useAppSelector(selectRefrigeratorFilters);

    const initialFilterOptions: RefrigeratorFilters = useMemo(() => {
        let initialFilters: RefrigeratorFilters = {};
        const setRefrigeratorFilters = (val: RefrigeratorFilters) => {
            initialFilters = val;
        };
        if (browsedRefrigerators.length > 0) {
            initializeFiltersOptions(browsedRefrigerators, setRefrigeratorFilters);
        }
        return initialFilters;
    }, [browsedRefrigerators]);

    const refrigeratorFilters = useMemo(() => {
        return _refrigeratorFilters ?? initialFilterOptions;
    }, [_refrigeratorFilters, initialFilterOptions]);

    const filteredRefrigerators = useMemo(() => {
        const selectedFilters: Map<string, FilterOption[]> = getSelectedFiltersMap(refrigeratorFilters);
        return filterAllEntries(Array.from(selectedFilters.entries()), browsedRefrigerators);
    }, [refrigeratorFilters, browsedRefrigerators]);

    return {
        filteredRefrigerators,
        refrigeratorFilters,
    };
};

export default useRefrigeratorFilters;
